export default __webpack_public_path__ + "static/media/game-2.55afaf9d.png";